export type PostType =
  | "speaker_announcement"
  | "exponat_announcement"
  | "event_announcement"
  | "event_attendance_announcement"
  | "event_review"
  | "short_post"
  | "first_spirit"
  | "first_spirit_referenten";

export type AuthFetch = (
  url: string,
  options?: RequestInit
) => Promise<Response>;

export class ContentGenerator {
  async generatePost(
    freeText: string,
    postType: PostType,
    language: string,
    apiFetch: AuthFetch
  ): Promise<string> {
    const response = await apiFetch(
      "/api/generate-post",
      {
        method: "POST",

        headers: {
          "Content-Type": "application/json",
        },

        body: JSON.stringify({
          text: freeText,
          postType,
          language,
        }),
      }
    );

    if (!response.ok) {
      const data = await response
        .json()
        .catch(() => null);

      throw new Error(
        data?.details ??
          data?.error ??
          "Fehler bei der Post-Generierung"
      );
    }

    const data = await response.json();

    return data.post;
  }
}